<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="headline font-weight-bold mb-4">
          Configurar comunicaciones
        </div>
        <v-breadcrumbs
          divider=">"
          :items="breadcrumbItems"
          class="pa-0"
        ></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text class="d-flex justify-space-between">
            <span class="title">
              Configurar popup de Notificación general
            </span>
            <v-btn
              color="primary"
              icon
              @click="toggleInformativeDialogConfig(true)"
            >
              <v-icon>
                tune
              </v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <InformativeDialogConfig />
  </v-container>
</template>

<script>

import { organizationService } from '@/services/organization.service'
import { mapMutations, mapState } from 'vuex'
import InformativeDialogConfig from '@/components/Comunications/InformativeDialogConfig.vue'

export default {
  name: 'Comunications',
  components: {
    InformativeDialogConfig
  },
  data () {
    return {
      breadcrumbItems: [
        {
          text: 'Comunicaciones',
          disabled: false
        },
        {
          text: 'Configurar comunicaciones',
          disabled: true,
          href: ''
        }
      ],
      isOpenDialogConfig: false,
      display: false,
      dialogTranslations: [],
      dialogConfig: {
        language_code: null,
        is_default: false,
        title: null,
        content: null,
        confirm: null
      }
    }
  },
  computed: {
    ...mapState({
      languages: ({ auth: { locales } }) => locales
    })
  },
  methods: {
    ...mapMutations({
      toggleInformativeDialogConfig: 'organization/toggleInformativeDialogConfig'
    }),
    async updateNotificationGeneral () {
      try {
        this.loading = true
        await organizationService.updateGeneralNotificationConfig({
          ...this.dialogConfig
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
